<template>
  <b-container fluid class="header">
    <b-row align-h="center">
      <b-col cols="10" class="langs">
        <a class="header__link" href="" @click.prevent="$emit('update:locale', locales.locale)">{{ locales.name }}</a>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col cols="10">
        <b-navbar toggleable="lg">
          <b-navbar-brand href="/">
            <img :src="logoURL" alt="Mount Sinai" />
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">

              <b-nav-item v-for="(menu, index) in menus" :to="menu.path" exact exact-active-class="active" :key="index">
                {{ menu.label }}
              </b-nav-item>

            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    locale: String,
    logo: Object,
    email: Object,
    phone: Object,
    localizations: Object,
    menus: Array
  },
  computed: {
    locales() {
      return this.localizations.data[0].attributes
    },
    logoURL() {
      return `/strapi${this.logo.data.attributes.url}`
    }
  },
  data: function () {
    return {
      routes: []
    }
  }
}
</script>

<style scoped src="@/assets/css/header.css" />
